<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width='600px')
      v-card
        v-card-text.px-3.pt-3.pb-1
          v-card(v-if="images.length == 0" outlined height="203" :style="{ 'background-color': $vuetify.theme.themes[$theme].primaryT08 }")
            div.fill-height
              template(v-if="loadingImage")
                div.d-flex.justify-center.align-end(style="height: 60%")
                  v-progress-circular(indeterminate color="grey")
              template(v-else)
                div.d-flex.justify-center.align-end(style="height: 70%")
                  div
                    div.mb-2(align="center")
                      eva-icon(name="image-outline" :fill="$vuetify.theme.themes[$theme].primaryT32" height="38" width="38")
                    div.file-layout.mb-4
                      v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") {{ $t('add_images') }}
                      input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 80px !important" multiple="multiple")
                div.d-flex.justify-center.align-end(style="height: 30%")
                  div.mb-4
                    div.c1.basic600--text.text-center {{ $t('max_image_filesize') }}
                    div.c1.basic600--text.text-center {{ $t('recommended_image_size') }}
          
          v-row(v-else no-gutters)
            template(v-for='(image, idx) in images')
              v-col(cols="4" style="padding: 1px")
                v-card.pa-1(flat tile :color="image.selected ? 'info400' : ''" @click="clickImages(idx)")
                  v-img(:src="image.url" aspect-ratio="1")
                    template(v-slot:placeholder)
                      v-row(class="fill-height ma-0" align="center" justify="center")
                        v-progress-circular(indeterminate color="grey")

        v-card-actions
          v-spacer
          template(v-if="images.filter(f => f.selected === true).length > 0")
            v-btn.button-Aa-tiny.custom-transform-class.text-none.px-2(color="danger500" text small @click="removeSelectedImages()")
              eva-icon.mr-2(name="trash-outline" :fill="$vuetify.theme.themes[$theme].danger500" height="12" width="12" style="margin-top: 1px")
              | {{ $t('remove_selected') }}
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading" :disabled="images.length == 0")
            .button-AA-small.basic100--text {{ $t('upload') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

let asyncForEach = async function(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}

export default {
  name: 'AddNewImageDialog',
  props: ['open', 'productId'],
  data: () => ({
    images: [],
    isLoading: false,
    loadingImage: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    clickImages(index) {
      this.$set(this.images[index], 'selected', !this.images[index].selected)
    },
    removeSelectedImages() {
      this.images = this.images.filter(x => !x.selected)
    },
    async clickSave() {
      if (!this.images.length === 0) {
        this.showMessage(['error', this.$t('error_message.image_file_is_required')])
        return
      }
      if (!this.images.length >= 10) {
        this.showMessage(['error', this.$t('error_message.max_images_ten')])
        return
      }
      this.isLoading = true
      try {
        await asyncForEach(this.images, async image => {
          var params = new FormData()
          params.append('image', image.file)
          const resp = await this.axios.post(`/products/${this.productId}/images/`, params)
          this.$emit('added', resp.data)
          this.images = this.images.filter(x => x !== image)
        })
      } catch (e) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
      this.isLoading = false
      if (this.images.length === 0) {
        this.showMessage(['success', this.$t('success_message.image_added')])
        this.showModal = false
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.loadingImage = true
      this.images = []
      files.forEach(async file => {
        try {
          const resizedImage = await resizeImage(file, 'product_image.jpeg')
          this.images.push({
            selected: false,
            url: resizedImage.dataURL,
            file: resizedImage.file
          })
        } catch (error) {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }
        setTimeout(() => {
          this.loadingImage = false
        }, 1500)
      })
    }
  }
}
</script>

<style scoped>
.container-image {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
</style>
